import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";
import { TEST_RESULT } from "../../../enums";
import { TEST_RESULT_MESSAGES } from "../../../const";

const state = () => ({
  isTestInProgress: false,
  testResult: TEST_RESULT.READY,
  testResultMessage: TEST_RESULT_MESSAGES.READY,
  testResultData: null
});

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
